module.exports = __webpack_public_path__ + "media/images/owl-4d461d2eb908e327b4d4ab50b3faf63c.svg";